var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopperLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 35,
    width: 92,
    height: 15,
    rx: 1,
    fill: "url(#paint0_angular_2713_35721)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 36V50",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 35.5V49.5",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 35.5V49.5",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5386 80.5249C43.9981 79.9848 43.5821 79.3331 43.3196 78.6156C43.0571 77.898 42.9543 77.1317 43.0186 76.3704C43.0828 75.609 43.3125 74.8708 43.6915 74.2073C44.0706 73.5439 44.5899 72.9712 45.2132 72.5292C46.2831 71.8209 47.5675 71.5102 48.8429 71.6512C50.1182 71.7922 51.3037 72.376 52.1931 73.3009L56.1673 77.2621V44.2527C56.1692 43.4867 56.3382 42.7304 56.6625 42.0365C56.9867 41.3426 57.4585 40.7277 58.0448 40.2349C58.6311 39.742 59.3179 39.383 60.0573 39.1829C60.7966 38.9828 61.5707 38.9464 62.3256 39.0762C63.5817 39.328 64.7091 40.0139 65.5101 41.0137C66.3112 42.0135 66.7348 43.2633 66.7067 44.5441V57.3777H79.6926C81.4987 57.3461 83.2827 57.7781 84.8743 58.6324C86.7168 59.6443 88.2076 61.1932 89.1482 63.0731C90.0889 64.953 90.4348 67.0747 90.1401 69.1561L89.0349 76.8762C88.4049 81.2575 86.3702 85.316 83.2363 88.4419C81.2676 90.4029 78.602 91.5035 75.8233 91.5027H59.8948C57.1171 91.5028 54.4525 90.4022 52.4844 88.4419L44.5386 80.5249Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_2713_35721",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.5 43) rotate(46.273) scale(15.9138 37.7752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0401886,
    stopColor: "#BF1932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158891,
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482525,
    stopColor: "#030972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#88B04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867719,
    stopColor: "#EB6E23"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopperLogo);
export default __webpack_public_path__ + "static/media/popperLogo.38ea0d623e8f8de7b366a0e9ebe631b8.svg";
export { ForwardRef as ReactComponent };